import React from'react';

type FileProps = {
    title: string,
    value: string,
    visible?: boolean
    hintText?: string,
};

const FileField = ({ title, value, visible = true, hintText }: FileProps) => {

    let titleLabel;
    if (title) {
        titleLabel = <div><b><label>{title}</label></b> <br /></div>
    }

    return (
        visible ?
            <div className="form-group ComponentDivs" >
                {titleLabel}
                <p className="HintText">{hintText}</p>
                <a href={value} target="_blank" rel="noreferrer noopener">Click here to download</a> 
            </div>
        : <></> // If not visible, return empty element instead of null
    );
}

export default FileField